export const BOARDS_POPUP_CLOSE_DELAY_MS = 8000;
export const BOARDS_TOASTER_ID = 'boards';
export const NEW_BOARD_PENDING_ID = -999 as const;
export const BOARDS_MENU_TOOLTIP_LOCAL_STORAGE_KEY =
  'boards-account-menu-tooltip';
export const BOARDS_MENU_TOOLTIP_DATE_END = '2026-03-15T00:00:00Z';
export const BOARDS_TRIGGER_TOOLTIP_DELAY_MS = 250;
export const SHARED_BOARD_REFERRAL_SESSION_KEY = 'ub_shared_board_referral';
